import PropTypes from "prop-types";
import { ExamContext } from "./examContext";
import { useEffect, useState } from "react";
import axios from "axios";
import arrayShuffle from "array-shuffle";
import { useNavigate, useLocation } from "react-router-dom";

export default function ExamContextProvider({ children }) {
  const [id, setId] = useState();
  const [data, setData] = useState();
  const [select, setSelect] = useState([]);
  const [chosen, setChosen] = useState([]);
  const [result, setResult] = useState(0);
  const [rightMarks, setRightMarks] = useState(0);
  const [wrongMarks, setWrongMarks] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const [wrongCount, setWrongCount] = useState(0);
  const [expiryTimestamp, setExpiryTimestamp] = useState();
  const [expiredMessage, setExpiredMessage] = useState(false);
  const [jsonQuestionPaper, setJsonQuesPaper] = useState();
  const [startTime, setStartTime] = useState(null);
  const [elapsedTime, setElapsedTime] = useState(null);
  const [secondTimerValue, setSecondTimerValue] = useState();
  const [secondTimer, setSecondTimer] = useState(false);
  const [examStartedAt, setExamStartedAt] = useState(); // when the start button is pressed or resumed from start_time 
  const [moveShuffle, setMoveShuffle] = useState(false);
  const [updateCount, setUpdateCount] = useState(1);
  const [examStart, setExamStart] = useState(false);// trigger to start exam/ show question paper

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const tokenData = JSON.parse(localStorage.getItem("faceAuthTokenData"));
    const access_token = tokenData?.token?.access;

    if (!access_token && location.pathname !== "/login") {
      navigate("/login");
    }
  }, [navigate, location.pathname]);

  const apiUrl = import.meta.env.VITE_APP_API;

  useEffect(() => {
    async function getExamPaperResult() {
      const access_token = JSON.parse(localStorage.getItem("faceAuthTokenData"))
        .token.access;

      const getUrl = `${apiUrl}/api/exam/admin/exam_question_paper/${id}/`;

      const getResult = await axios.get(getUrl, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      });

      setExamStartedAt(getResult.data.exam_started_at);
      setSecondTimerValue(getResult.data.second_timer_negetive_mark);
    }
    if (id) getExamPaperResult();
  }, [id, setExamStartedAt, apiUrl]);

  useEffect(() => {
    const url = `${apiUrl}/api/exam/admin/exam_question_paper/${id}/`;

    const access_token = JSON.parse(localStorage.getItem("faceAuthTokenData"))
      .token.access;

    const getExamQuestionPaper = async () => {
      const getData = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      });
      if (getData.status === 200) {
        setData(getData.data);
        
      }
      console.log("get data", getData.data);
      const updatedQuestions = [];

      for (const question of getData.data.json_question_paper) {
        // eslint-disable-next-line no-unused-vars
        const { select, ...rest } = question;
        updatedQuestions.push(rest);
      }

      // const shuffledQuestions = arrayShuffle(updatedQuestions);

      // const minLength = Math.min(
      //   shuffledQuestions.length,
      //   getData.data.number_of_question
      // );

      // let finalUpdatedQuestions = [];

      // for (let i = 0; i < minLength; i++) {
      //   finalUpdatedQuestions.push(shuffledQuestions[i]);
      // }

      // setJsonQuesPaper(finalUpdatedQuestions);

      if (
        getData.data.shuffle
        // || moveShuffle === true ||
        // moveShuffle === false
      ) {
        const shuffledQuestions = arrayShuffle(updatedQuestions);

        const minLength = Math.min(
          shuffledQuestions.length,
          getData.data.number_of_question
        );

        let finalUpdatedQuestions = [];

        for (let i = 0; i < minLength; i++) {
          finalUpdatedQuestions.push(shuffledQuestions[i]);
        }
        finalUpdatedQuestions.sort((x, y) => x.pk - y.pk);
        setJsonQuesPaper(finalUpdatedQuestions);
        console.log("updated in this block");
      } else {
        const minLength = Math.min(
          updatedQuestions.length,
          getData.data.number_of_question
        );
        let finalUpdatedQuestions = [];
        for (let i = 0; i < minLength; i++) {
          finalUpdatedQuestions.push(updatedQuestions[i]);
        }
        finalUpdatedQuestions.sort((x, y) => x.pk - y.pk);
        setJsonQuesPaper(finalUpdatedQuestions);
        console.log("updated in that block");
      }
    };

    const retrieveExamRecord= async()=>{
      const url = `${apiUrl}/api/exam/retrieve_live_exam_record/${id}`;
      try {
        const getData = await axios.get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${access_token}`,
          },
        });

        if (getData.status === 200) {
          setJsonQuesPaper(JSON.parse(getData.data.data.question_paper));
          setUpdateCount(getData.data.data.update_count);
          setExamStart(true);
          setExamStartedAt(getData.data.data.start_time);
          console.log(getData.data);
        }else{
          await getExamQuestionPaper();
        }
      } catch (error) {
        await getExamQuestionPaper();
        
      }
    }
    if (id) retrieveExamRecord();
    console.log('jsonQuestionPaper', jsonQuestionPaper);
  }, [id, apiUrl, moveShuffle]);

  return (
    <ExamContext.Provider
      value={{
        id,
        setId,
        data,
        setData,
        select,
        setSelect,
        chosen,
        setChosen,
        result,
        setResult,
        rightMarks,
        setRightMarks,
        wrongMarks,
        setWrongMarks,
        submitted,
        setSubmitted,
        wrongCount,
        setWrongCount,
        expiryTimestamp,
        setExpiryTimestamp,
        expiredMessage,
        setExpiredMessage,
        jsonQuestionPaper,
        setJsonQuesPaper,
        startTime,
        setStartTime,
        elapsedTime,
        setElapsedTime,
        secondTimerValue,
        setSecondTimerValue,
        secondTimer,
        setSecondTimer,
        examStartedAt,
        setExamStartedAt,
        moveShuffle,
        setMoveShuffle,
        updateCount,
        setUpdateCount,
        examStart,
        setExamStart,
      }}
    >
      {children}
    </ExamContext.Provider>
  );
}

ExamContextProvider.propTypes = {
  children: PropTypes.any,
};


export const parseCustomDate= (str)=>{

  if (!str || typeof str !== "string") {
    return new Date();
  }
  const [date, time] = str.split(' ');
  const [day, month, year] = date.split('/');
  return new Date(`${year}-${month}-${day}T${time}`);
}
